export type Channel = {
  id: number;
  code: string;
  title: string;
  slug: string;
  type: "chat" | "email";
  description?: string;
  isActive: boolean;
  defaultAssignee?: string;
};

export const mockChannels: Channel[] = [
  {
    id: 1,
    code: "CH-01",
    title: "Live Chat - EN",
    slug: "live-chat-en",
    type: "chat",
    description: "English live chat support",
    isActive: true,
    defaultAssignee: "John Smith",
  },
  {
    id: 2,
    code: "CH-02",
    title: "Live Chat - ES",
    slug: "live-chat-es",
    type: "chat",
    description: "Spanish live chat support",
    isActive: true,
    defaultAssignee: "Maria Gomez",
  },
  {
    id: 3,
    code: "CH-03",
    title: "Support Email - General",
    slug: "support-email-general",
    type: "email",
    description: "General support email channel",
    isActive: true,
    defaultAssignee: "Support Team",
  },
  {
    id: 4,
    code: "CH-04",
    title: "Support Email - VIP",
    slug: "support-email-vip",
    type: "email",
    description: "VIP customers email support",
    isActive: true,
    defaultAssignee: "VIP Manager",
  },
  {
    id: 5,
    code: "CH-05",
    title: "Live Chat - FR",
    slug: "live-chat-fr",
    type: "chat",
    description: "French live chat support",
    isActive: false,
    defaultAssignee: "Pierre Dubois",
  },
  {
    id: 6,
    code: "CH-06",
    title: "Support Email - Compliance",
    slug: "support-email-compliance",
    type: "email",
    description: "Compliance and legal requests",
    isActive: true,
    defaultAssignee: "Compliance Officer",
  },
  {
    id: 7,
    code: "CH-07",
    title: "Live Chat - DE",
    slug: "live-chat-de",
    type: "chat",
    description: "German live chat support",
    isActive: true,
    defaultAssignee: "Hans Müller",
  },
];

export const assignees = [
  { value: "john_smith", label: "John Smith" },
  { value: "anna_brown", label: "Anna Brown" },
  { value: "support_team", label: "Support Team" },
];
